import React, { useState } from "react";
import headlogo from "../../Images/Isolation_Mode.png";
import isolation from "../../Images/Isolation_Mode (1).png";
import isolation2 from "../../Images/Isolation_Mode (2).png";
import isolation3 from "../../Images/Isolation_Mode (3).png";
import Header2 from "../../Layout/Header2";
import "./Pricingplans.css";
import Plans from "./Plans";
import SpotBanner from "./SpotBanner";
const Pricingplans = () => {
  const [selectedCity, setSelectedCity] = useState("Gurgaon");
  return (
    <>
      {/* This Section is taken from the about_us_section */}
      <section className="">
        <div className="pricing_plans_container">
          <Header2 />
          {/* <div>
            <h1 className=" about_head">
              Pricing Plans
              <span>
                <img className="img_logo2" src={headlogo} />
              </span>
            </h1>
            <p className="about_head_para" style={{ padding: "0 120px" }}>
              Choose the plan that fits your real estate goals — flexible,
              transparent, and built for every professional. Best for growing
              real estate professionals dealing across multiple areas like
              Gurgaon, Noida, and South Delhi. Get access to a wider data pool,
              daily updates, and verified contact information for faster deal
              closures.
            </p>
          </div>
          <img className="isolation_img_5" src={isolation} />
          <img className="isolation_img_6" src={isolation2} />
          <img className="isolation_img_4" src={isolation3} /> */}
          <div className="pricing-banner">
            <div className="pricing-overlay"></div>
            <h1 className="pricing-title">Pricing Plans</h1>
          </div>
        </div>
      </section>

      {/* The section ends here */}
      <Plans setSelectedCity={setSelectedCity} />
      <SpotBanner selectedCity={selectedCity} />
    </>
  );
};

export default Pricingplans;
